import { OwnerInfo } from "./OwnerInfo";
import { PlanInfo } from "./PlanInfo";
import { AgoraInfo } from "./AgoraInfo";
import { Tag } from "./Tag";
import { VideoStreamingTime } from "./VideoStreamingTime";
import { type Library } from "./Library";
import type { Chapter } from "./Chapter";
import { type LIVE_STATUS } from "~/consts/contentsConfig";

// ライブデータ
// ライブ、ライブスケジュール、アーカイブ動画で共通
export class LiveInfo {
  constructor(
    public id: string,
    public contentsTitle: string, // 動画のタイトル
    public contentsType: string, // コンテンツタイプ。ライブ、ライブスケジュール、アーカイブ動画
    public description: string, // 動画の説明
    public agora: AgoraInfo | undefined, // agora接続情報
    public thumbnailImage: string, // サムネイル画像
    public streamingVideoSettingList: VideoStreamingTime[],
    public tags: Tag[],
    public liveScheduleDateTime: string, // ライブ開始予定時間
    public liveStartDateTime: string | undefined, // ライブ開始時間
    public liveEndDateTime: string | undefined, // ライブ終了時間
    public liveStatus: LIVE_STATUS, // 配信ステータス
    public viewCount: number, // 閲覧者数
    public shareCount: number, // シェアされた数
    public planOwner: OwnerInfo | undefined, // 配信者情報
    public addMyList: boolean,
    public addMyReservation: boolean,
    public videoStreamingFlag: boolean,

    public plan: PlanInfo | undefined,
    public isFree: boolean,
    public isFeatured: boolean,
    // [ユーザー状態] 現在のユーザーがこのコンテンツにアクセス可能か
    // 限定プラン未設定: 講座契約済みならtrue
    // 限定プラン設定済: 該当プラン入会済みならtrue
    // 講師・未契約者: false
    public isContract: boolean,
    // アーカイブ向け情報
    public contentsUrl: string,
    public moviePlayTimeSec: number,
    public isUnread: boolean,
    public contentsKey: string, // コンテンツキー
    public thumbnailKey: string,
    public isOwner: boolean,
    public isGood: boolean, // 自分がいいねしているか
    public goodCount: number, // いいね数
    public libraries: Library[] = [], // TODO:API追加依頼中
    public isComplete: boolean, // 視聴完了か
    public publishStatus: "PUBLISH" | "PRIVATE" | "LIMITED", // 公開設定
    public contentsSubUrl: string, // ファイルパス。contentsUrlにエラーがある場合に使用
    public liveUserId: string, // ライブ配信者のユーザID

    public isBookmark: boolean = false, // ブックマークしているか

    public contentsGroupKey: string | null = null, // コンテンツグループキー

    public chapters: Chapter[] | undefined = undefined, // チャプター
    public viewingRestrictionDays: number | null = null, // 閲覧権限制限日数
    // [コンテンツ設定] 限定プラン制限の有無
    public isLimitedPlan: boolean = false,
    // [コンテンツ設定] アクセス可能な限定プランID一覧
    public limitedPlanPriceIds: number[] = [],
    // [ユーザー状態] プラン価格によって制限されているか（APIで取得ではなくプログラムで付与）
    public isLimitedByPlanPrice: boolean = false,
    public m3U8Url: string, // 追っかけ再生用のm3u8ファイルURL
  ) {}
}
